module.exports = __webpack_public_path__ + "static/media/hotel.670b0997.svg";